<template>
  <div>
    <div>
      <div v-if="!arrayData.name" :class="arrayData.divClass">
        <p :class="arrayData.style.class">
          {{ String(arrayData.value) }}
        </p>
      </div>
      <div velse :class="arrayData.divClass">
        <div :class="arrayData.style.divClassFirst">
          <div v-if="!hasName[0]">
            <p :class="arrayData.style.class">
              {{ arrayData.name }}
            </p>
          </div>
          <div v-else>
            <p
              v-for="(itemDown, index) in hasName"
              :key="index"
              :class="arrayData.style.class"
            >
              {{ itemDown.name }}
            </p>
          </div>
        </div>
        <div :class="arrayData.style.divClassSecond">
          <div
            :class="itemDown.style.class"
            v-for="(itemDown, index) in arrayData.value"
            :key="index"
          >
            <p v-if="itemDown.value" :class="arrayData.style.class">{{ String(itemDown.value) }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    arrayData: {
      type: Object
    }
  },
  mounted() {
    // console.log("object data", this.arrayData);
  },
  computed: {
    hasName() {
      let object = this.arrayData;

      let hasName = this.lodash.filter(object.value, a => {
        return a.name;
      });
      // console.log("hasName", hasName);
      return hasName;
    }
  }
};
</script>

<style lang="scss"></style>
